
<template>
    <div class="header_box template-demos">
        <div id="navHeaderForTutorial" class="navHeader slide-bottom fix" >
            <header class="navbar navbar-expand-lg navbar-light header">
                <button class="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false" aria-label="navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <a class="navbar-brand nav-href" href="https://www.thingjs.com/guide">
                    <div class="title">
                        <div class="logo"></div>
                    </div>
                </a>
                <div class="collapse navbar-collapse" id="navbarHeader">
                    <ul class="navbar-nav mt-2 mt-lg-0" id="sub-site-nav">
                        <li class="nav-menu campusLi nav_mobile pingtaiyuyingyongli">
                            <!-- 新增id控制指引功能-->
                            <!-- <div id='campusBuilderDownLoad' data-act="campus" class="nav-link nav-href changNav" data-toggle="dropdown"
                            i18n="nav.component">平台工具</div> -->
                            <div id='campusBuilderDownLoad' data-act="campus" class="nav-link nav-href changNav pingtaiyuyingyong" data-toggle="dropdown"
                                i18n="nav.component">
                                <span>平台产品</span>
                            </div>
                            <!-- 平台与应用 -->
                            <div class="pf-alt">
                                <ul class="pf-alt-content">
                                <!-- 平台与应用介绍 -->
                                <li class="pf-alt-left">
                                    <h2 class="pf-alt-left-title">平台与应用</h2>
                                    <p class="pf-alt-left-text">
                                    ThingStudio森工厂是数字孪生一站式工具平台，它提供全系列的生产设备，能够灵活组成各式各样的生产线，去满足各行各业、各种数字孪生应用场景的需求。
                                    </p>
                                </li>
                                <!-- 平台与应用内容 -->
                                <div class="pf-alt-right">
                                    <!-- 低代码 -->
                                    <div class="pf-alt-right-first">
                                    <h2 class="pf-alt-right-firstT  _arrow_" @mouseover="pfAltList(7)" @click="hrefPageClick('studio')">
                                      <span>零代码</span>
                                      <span style="font-size: 17px;margin-top: 2px;">（ThingJS-X）</span>
                                      <span class="arr_arrow"></span>
                                    </h2>
                                    <ul class="pf-alt-right-first-list">
                                        <a href="javaScript:;"  @mouseover="pfAltList(7)" @click="hrefPageClick('studio')">
                                          <h4>开发环境</h4>
                                          <p>全流程 0代码</p>
                                          <img title='打开"低代码"' src="https://www.thingjs.com/guide/image/mainNew2/product_icon7.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://studio.thingjs.com/zeroCode');" class="js jsheaderIcon headerIcon">
                                        </a>
                                        <a href="javaScript:;"  @mouseover="pfAltList(7)" @click="hrefPageClick('zeroCode')">
                                          <h4>使用介绍</h4>
                                          <p>配置交付数字孪生应用</p>
                                        </a>
                                        <!-- <a href="javaScript:;" @mouseover="pfAltList(26)" @click="hrefPageClick('speedcityshow')">
                                        <h4>3D城市</h4>
                                        <p>快速生成3D城市场景</p>
                                        </a>				 -->
                                    </ul>
                                    <!-- ThingJS行业模板 -->
                                      <!-- <div class="application" >
                                        <h2 class="pf-alt-right-beforeT pf-alt-right-firstH">
                                          <span>ThingJS行业模板</span>
                                        </h2>
                                        <ul class="pf-alt-right-first-list">
                                          <a href="javaScript:;"  @mouseover="pfAltList(29)"  @click="hrefPageClick('intelligentPower')">
                                            <h4>智慧电力</h4>
                                            <p>全局用电态势感知</p>
                                          </a>
                                        </ul>
                                      </div> -->
                                    </div>
                                    <!-- 森产品 -->
                                    <div class="pf-alt-right-before">
                                    <h2 class="pf-alt-right-beforeT">
                                        <a class="factory" href="javaScript:;">
                                        森产品
                                        </a>
                                        <!-- <div class="tryStudio" @click = "fileclick1(true,'https://studio.thingjs.com/lowCode')"><img src="/guide/image/new/studio-icon.png" alt=""><span>立即试用</span></div> -->
                                    </h2>
                                    <ul class="pf-alt-right-before-list">
                                      <a href="javaScript:;" @mouseover="pfAltList(1)" @click="hrefPageClick('platform')">
                                        <h4>低代码</h4>
                                        <p>低代码开发数字孪生</p>
                                        <img title='打开"低代码"' src="https://www.thingjs.com/guide/image/mainNew2/product_icon6.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及"  @click="$event.stopPropagation(),fileclick1(true,'https://www.thingjs.com/guide/platform/');" class="xheaderIcon headerIconJF headerIcon">
                                      </a>
                                      <a href="javaScript:;" @mouseover="pfAltList(12)" @click="hrefPageClick('dcv')">
                                        <h4>森机房</h4>
                                        <p>可视化构建机房运维场景</p>
                                        <img title='打开"森机房"' src="https://www.thingjs.com/guide/image/mainNew2/dcvIcon.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://dcv.thingjs.com/thing/share/8rxi1t9c6874uwb4');" class="dcvheaderIcon headerIconJF headerIcon">
                                        </a>
                                      <a href="javaScript:;" @mouseover="pfAltList(11)" @click="hrefPageClick('campus')">
                                        <h4>森园区</h4>
                                        <p>游戏式搭建3D园区</p>
                                        <img title='打开"森园区"' src="https://www.thingjs.com/guide/image/mainNew2/product_icon1.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://campus.thingjs.com/');" class="cuampusheaderIcon headerIconJF headerIcon">
                                        </a>
                                        <a href="javaScript:;" @mouseover="pfAltList(14)" @click="hrefPageClick('liveServer')">
                                        <h4>森视频</h4>
                                        <p>视频数据一站对接</p>
                                        <img title='打开"森视频"' src="https://www.thingjs.com/guide/image/mainNew2/senshipin.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://www.thingjs.com/guide/liveServer/');" class="sspheaderIcon headerIconJF headerIcon">
                                        </a>
                                        <a  href="javaScript:;" @mouseover="pfAltList(13)" @click="hrefPageClick('city')">
                                        <h4>森城市</h4>
                                        <p>快速生成酷炫3D城市</p>
                                        <img title='打开"森城市"' src="https://www.thingjs.com/guide/image/mainNew2/product_icon2.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://city.thingjs.com');" class="cityheaderIcon headerIconJF headerIcon">
                                        </a>
                                        <a href="javaScript:;" @mouseover="pfAltList(16)" @click="hrefPageClick('mod')">
                                        <h4>森模型</h4>
                                        <p>上万种3D模型&nbsp;覆盖多行业</p>
                                        <img title='打开"森模型"' src="https://www.thingjs.com/guide/image/mainNew2/senmoxing.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://studio.thingjs.com/resource/main');" class="modeheaderIcon headerIconJF headerIcon">
                                        </a>
                                        <a href="javaScript:;" @mouseover="pfAltList(15)" @click="hrefPageClick('chartBuilder')">
                                        <h4>森大屏</h4>
                                        <p>拖拽组装可视化大屏</p>
                                        <img title='打开"森大屏"' src="https://www.thingjs.com/guide/image/mainNew2/product_icon3.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://charts.thingjs.com/kunpeng/editor/new');" class="dpheaderIcon headerIconJF headerIcon" >
                                        </a>
                                        <!-- <a href="javaScript:;" @mouseover="pfAltList(18)" @click="hrefPageClick('plugin')">
                                        <h4>森Max</h4>
                                        <p>3DsMax插件&nbsp;让设计更高效</p>
                                        </a> -->
                                        <a href="javaScript:;" @mouseover="pfAltList(17)" @click="hrefPageClick('topoBuilder')">
                                        <h4>森拓扑</h4>
                                        <p>高效构建活的二维场景</p>
                                        <img title='打开"森拓扑"' src="https://www.thingjs.com/guide/image/mainNew2/product_icon4.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://topo.thingjs.com/#/new');" class="topoheaderIcon headerIconJF headerIcon">
                                        </a>
                                        <!-- <a href="javaScript:;" @mouseover="pfAltList(20)" @click="hrefPageClick('bim')">
                                        <h4>森BIM</h4>
                                        <p>Revit插件&nbsp;秒变轻量化</p>
                                        </a> -->
                                        <a href="javaScript:;" @mouseover="pfAltList(19)" @click="hrefPageClick('dix')">
                                        <h4>森数据</h4>
                                        <p>物联数据一键对接</p>
                                        <img title='打开"森数据"' src="https://www.thingjs.com/guide/image/mainNew2/product_icon5.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://dix.thingjs.com');" class="dixheaderIcon headerIconJF headerIcon">
                                        </a>
                                        <!-- <a href="javaScript:;" @mouseover="pfAltList(27)" @click="hrefPageClick('facade')">
                                        <h4>森建筑</h4>
                                        <p>参数化生成建筑模型</p>
                                        <img title='打开"森建筑"' src="https://www.thingjs.com/guide/image/mainNew2/senjianzhu.png" alt="森工厂数字孪生引擎工具平台，让数字孪生变简单，不再神话般遥不可及" @click="$event.stopPropagation(),fileclick1(true,'https://facade.thingjs.com/');" class="facadeheaderIcon headerIconJF headerIcon">
                                        </a> -->
                                    </ul>
                                    </div>
                                    <!-- 森服务 -->
                                    <div class="pf-alt-right-final">
                                    <h2 class="pf-alt-right-finalT">
                                        <span>
                                        森服务
                                        </span>
                                    </h2>
                                    <ul class="pf-alt-right-final-list">
                                        <a href="javaScript:;" @mouseover="pfAltList(21)" @click="hrefPageClick('modeling')">
                                        <h4>建模服务</h4>
                                        <p>模型质量高，效率更快捷</p>
                                        </a>
                                        <a href="javaScript:;" @mouseover="pfAltList(22)" @click="hrefPageClick('development')">
                                        <h4>开发服务</h4>
                                        <p>快速构建3D可视化，享受高效开发</p>
                                        </a>
                                        <a href="javaScript:;" @mouseover="pfAltList(24)" @click="hrefPageClick('support')">
                                        <h4>支持服务</h4>
                                        <p>技术支持，助力成功之路</p>
                                        </a>
                                        <a href="javaScript:;" @mouseover="pfAltList(28)" @click="hrefPageClick('tiltPhotography')">
                                        <h4>倾斜摄影服务</h4>
                                        <p>提供倾斜摄影航拍及数据处理服务</p>
                                        </a>
                                    </ul>
                                    </div>
                                    <!-- 鼠标滑过展示 -->
                                    <div class="pf-alt-mouse-hover-show">
                                    <div class="pf-alt-mouse-hover-show-content">
                                        <h2>
                                        <span>
                                            零代码
                                        </span>
                                        </h2>
                                        <p>ThingJS-X数字孪生零代码开发平台，无需研发人员，普通业务人员培训3天可独立完成项目。内置丰富模板，开箱即用，提升项目交付效率。</p>
                                    </div>
                                    </div>
                                </div>
                                </ul>
                            </div>
                        </li>
                        <a class="nav-link nav-bar nav-href _公开项目 changNav" href="https://store.thingjs.com/projects" data-act="projectList" data-i18n="nav.public" data-toggle="collapse" i18n="nav.component" aria-expanded="false">资源中心</a>
                        <a id="lowCodeDevelopment" class="nav-link nav-href changNav" href="https://www.thingjs.com/guide/?m=sample" data-act="sample" i18n="nav.online">低代码开发</a>
                        <a id="zeroCodeDevelopment" class="nav-link nav-href changNav" href="https://studio.thingjs.com/zeroCode" data-act="" i18n="nav.online">森工厂</a>



                        <!-- <a class="nav-link nav-href changNav" href="https://www.thingjs.com/guide/?m=model" data-act="model" style="display: none" i18n="nav.3DBase">模型库</a> -->
                        <a class="nav-link nav-href changNav" href="https://www.thingjs.com/guide/?m=help" data-act="help" style="display: none">常见问题</a>
                        <a class="nav-link nav-href changNav" href="https://www.thingjs.com/guide/price" data-act="price"  i18n="nav.price">价格</a>
                        <!-- <li class="nav-menu campusLi nav_mobile price-list-li" >
                          <a class="nav-link nav-href changNav nav_mobile price-list-li" href="javaScript:;" data-act="price"
                          data-backhref="?m=price" i18n="nav.price" data-name = "price" @click="switchPricePage(1)">价格</a>
                          <div class="price-list">
                            <div class="infos">
                                <div class="top-content">
                                        <div class="lowcode common" @click="switchPricePage(1)">
                                        <div class="title">低代码套装</div>
                                        <div class="text">· 低代码IDE+配套森工具</div>
                                        <div class="text">· 适合前端开发者</div>
                                        </div>
                                        <div class="info_line"></div>
                                        <div class="zerocode common" @click="switchPricePage(2)">
                                        <div class="title">零代码套装</div>
                                        <div class="text">· 零代码工具+配套森工具</div>
                                        <div class="text">· 免开发 适合快速实施</div>
                                    </div>
                                </div>
                                <hr class="line">
                                <div class="bottom-content common" @click="switchPricePage(3)">
                                    <div class="title">森工厂价格一览</div>
                                    <div class="text">· 了解森工厂全系列工具链多种单独与组合使用的报价体系</div>
                                    <div class="text">· 低代码 | 零代码 | 森园区 | 森城市 | 森大屏 | 森拓扑 | 森数据</div>
                                </div>
                            </div>
                          </div>
                        </li> -->
                        <a class="nav-link nav-href changNav wendang"  i18n="nav.word" href="https://study.thingjs.com" target="_blank" data-act="tutorial">森学院</a>
                        <div class="nav-href changNav">
                            <div class="nav-link" style="align-items: center;">
                                <span id="phone" class="phone"></span>
                                <a style="cursor:default;padding: 0 4px;"><span>400-666-9832</span></a>
                            </div>
                        </div>
                        <!-- <a class="nav-href changNav contact" href="javascript:void(0);" style="cursor:default;"><img src="../../static/img/phone1.png" style="width: 16px;height: 16px;margin: 0px 4px 4px 0px;">400-666-9832</a> -->
                    </ul>
                    <ul class="navbar-nav mr-auto mt-2 mt-lg-0 query-group" style="display: flex;justify-content: left;height:70px;">
                        <span class="nav-separator"></span>
                        <li>
                          <a class="nav-link changNav nav-href add" href="javascript:void(0);"  v-on:click="showPanel('Model','申请建模')" binded="true" id="modelSer" style="cursor: pointer;position: relative; white-space:nowrap;text-overflow:ellipsis;top:19%;"><span style="color: #fff; z-index: 1;">申请服务</span>
                          <!-- <img src="../../static/img/new.png" alt="" class="newPng"> -->
                          </a>
                        </li>
                        <!-- <li>
                          <a class="nav-link changNav nav-href" href="javascript:void(0);"  v-on:click="showPanel('dev','请求协助')" binded="true" id="development" style="cursor: pointer;position: relative; white-space:nowrap; text-overflow:ellipsis;top:19%;"><span style="color: #fff; z-index: 1;">请求协助</span>
                          </a>
                        </li> -->
                        <li v-if="isRootcloud">
                          <a class="nav-link changNav nav-href" href="javascript:void(0);" id="developer" v-on:click="showPanel('VIP','开通VIP')"
                            style="cursor: pointer;position: relative; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;top:19%;"><span style="color: #fff; z-index: 1;">升级VIP</span></a>
                        </li>
                        <li>
                          <a class="nav-link logout-show nav-login changNav" data-log="-1" id="login" style="display:none;border-radius: 30px;width: 80px; margin-top: 13px; height: 30px;font-size: 14px;line-height: 14px; text-align: center;white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">登录</a>
                        </li>
                        <li>
                          <a class="nav-link" id="nav-reg" style="display:none;border-radius: 30px;width: 80px; height: 30px; border: 1px solid #FF7F00; margin-top: 13px; text-align: center; color: #FF7F00;font-size: 14px;line-height: 14px;" >注册</a>
                        </li>
                        <li class="nav-link vipLi">
                            <span class="vip" title="商业开发者" alt="商业开发者"></span>
                            <div class="logout-show nav-logout" style="display:none" id="headimg"></div>
                            <ul class="userInfoBox" id="userInfo" style="font-size:12px;">
                              <li style="cursor:pointer;"><span style="margin-left: 15px;margin-right: 10px;"><img src="../../static/img/header/signin.png" style="width:16px;"></span><a class="see-more" href="javascript:void(0)"  v-on:click="showSignin()" style="top:2px;">签到</a></li>
                              <li style="border-top: 1px solid #eeeeee;margin:0 -6px;"><div class="line"></div></li>
                              <li style="cursor:pointer;"><span style="margin-left: 15px;margin-right: 10px;"><img src="../../static/img/header/person.png" style="width:16px;"></span><a class="see-more" href="javascript:void(0)"  onclick="openPer()" style="top:2px;">个人信息</a></li>
                              <li style="cursor:pointer;"><span style="margin-left: 15px;margin-right: 10px;"><img src="../../static/img/header/ticket.png" style="width:16px;"></span><a class="see-more" href="javascript:void(0);" onclick="openTicket()" style="top:1px;">我的订单</a></li>
                              <li style="border-top: 1px solid #eeeeee;margin:0 -6px;"><div class="line"></div></li>
                              <li class="logout" style="cursor:pointer;" id="logout"><span style="margin-left: 15px;margin-right: 10px;"><img src="../../static/img/header/outlog.png" style="width:16px;margin-bottom: 3px;"></span><a style="cursor:pointer;">退出</a></li>
                            </ul>
                        </li>
                    </ul>
                    <div id="login_container"></div>
                </div>
            </header>
        </div>
        <!-- 手机端抽拉式导航 -->
        <div id = "wapNav" class = "wap-nav">
            <div class = "wap-nav-content">
                <!-- 收起展开按钮 -->
                <div class = "put-on" style = "padding-top: 7px;">
                    <!-- 展开 -->
                    <p class = "wap-nav-put" @click = "wapNavPut()" style = "display: block;">
                        <svg t="1619186169738" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6814" width="32" height="32"><path d="M122.7 229.4h781.1c20.7 0 37.5-16.8 37.5-37.5s-16.8-37.5-37.5-37.5H122.7c-20.7 0-37.5 16.8-37.5 37.5s16.8 37.5 37.5 37.5zM903.8 473.1H122.7c-20.7 0-37.5 16.8-37.5 37.5s16.8 37.5 37.5 37.5h781.1c20.7 0 37.5-16.8 37.5-37.5-0.1-20.7-16.9-37.5-37.5-37.5zM903.8 791H122.7c-20.7 0-37.5 16.8-37.5 37.5S102 866 122.7 866h781.1c20.7 0 37.5-16.8 37.5-37.5S924.4 791 903.8 791z" p-id="6815" fill="#7e7e7e"></path></svg>
                    </p>
                    <!-- 收起 -->
                    <p class = "wap-nav-on" @click = "wapNavOn()" style = "display: none;">
                        <svg t="1619186023729" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6559" width="32" height="32"><path d="M566.97558594 521.09667969L856.8828125 231.18945312c14.63378906-14.63378906 14.63378906-38.75976563 0-53.39355468l-1.58203125-1.58203125c-14.63378906-14.63378906-38.75976563-14.63378906-53.39355469 0L512 466.51660156 222.09277344 176.21386719c-14.63378906-14.63378906-38.75976563-14.63378906-53.39355469 0l-1.58203125 1.58203125c-15.02929688 14.63378906-15.02929688 38.75976563 0 53.39355469l289.90722656 289.90722656L167.1171875 811.00390625c-14.63378906 14.63378906-14.63378906 38.75976563 0 53.39355469l1.58203125 1.58203125c14.63378906 14.63378906 38.75976563 14.63378906 53.39355469 0L512 576.07226563 801.90722656 865.97949219c14.63378906 14.63378906 38.75976563 14.63378906 53.39355469 0l1.58203125-1.58203125c14.63378906-14.63378906 14.63378906-38.75976563 0-53.39355469L566.97558594 521.09667969z" fill="#7e7e7e" p-id="6560"></path></svg>
                    </p>
                </div>
                <!-- logo -->
                <h1 class = "wap-nav-logo">
                    <a href = "https://www.thingjs.com/guide/">
                        <img src = "https://www.thingjs.com/guide/image/new/logo-b.png" alt = "Thingjs">
                    </a>
                </h1>
                <!-- 登录注册 -->
                <div class = "wap-nav-login">
                    <p class = "login-icon nav-login-two" data-log = "-1">
                        <svg t="1619601852895" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6136" width="32" height="32"><path d="M634.342 589.022c105.11 41.118 185.376 133.808 207.609 249.08 2.965 15.374-7.095 30.241-22.469 33.206-15.374 2.965-30.24-7.094-33.205-22.468-25.155-130.425-139.813-226.122-274.22-226.122-134.407 0-249.067 95.7-274.22 226.125-2.965 15.374-17.831 25.434-33.205 22.47-15.374-2.966-25.434-17.832-22.469-33.206 22.23-115.275 102.498-207.967 207.61-249.085-76.52-42.89-128.237-124.79-128.237-218.77 0-138.402 112.16-250.602 250.522-250.602 138.36 0 250.52 112.2 250.52 250.602 0 93.98-51.716 175.88-128.236 218.77z m71.537-218.77c0-107.092-86.78-193.902-193.821-193.902-107.043 0-193.822 86.81-193.822 193.902 0 107.09 86.779 193.9 193.822 193.9 107.042 0 193.82-86.81 193.82-193.9z" p-id="6137" fill="#7e7e7e"></path></svg>
                    </p>
                    <p class = "head-or-name vipLi" @click = "audittojjles()">
                    <span id="headimgs" class = "wap-nav-name"></span>
                    <span class="vip" title="商业开发者" alt="商业开发者"></span>
                    </p>
                </div>
            </div>
        </div>
        <div class = "logouttwo" style="cursor:pointer;">
          <ul class="logouttwo-ul">
            <li class="logouttwo-li">
              账号：<span id="login" class = "wap-nav-head login-active login-name"  data-log = "-1"></span>
              <span class = "quit-login"  id="logouttwo">退出</span>
            </li>
            <!-- <li class="logouttwo-li" @click="showSigninPage('from_main')">
              签到
            </li>
            <li class="logouttwo-li" @click="openPer()">
              个人信息
            </li>
            <li class="logouttwo-li" @click="openTicket()">
              我的订单
            </li> -->
            <li class="logouttwo-li">
              联系客服：400-666-9832
            </li>
          </ul>
          <!-- <img src="../../guide/image/outlog.png" style="width:16px;margin-bottom: 3px;" alt = "退出"/> -->
        </div>
        <div id = "bg-shadow1"></div>
        <div id = "bg-shadow2"></div>
        <div class = "wap-nav-drawer">
            <ul>
                <li><a href = "https://store.thingjs.com/projects">资源中心</a></li>
                <li><a href = "https://www.thingjs.com/guide/platform/">平台产品</a></li>
                <li><a href = "https://www.thingjs.com/guide/speedcityshow/">3D城市</a></li>
                <!-- <li><a href = "https://www.thingjs.com/guide/store/">应用商店</a></li> -->
                <li><a href = "https://www.thingjs.com/guide/price/">价格</a></li>
                <li><a href = "https://developer.thingjs.com/">社区</a></li>
            </ul>
        </div>
        <!-- <div class="pay-mb" id="pay-mb-out" style="display: none;"></div> -->
        <div class="sketchfabTip" v-if="showSketchfabMsg">
          <div class="main">
            <div class="title">
              <span class="head">预览提示</span>
              <i class="layui-layer-ico layui-layer-close layui-layer-close1" @click="showSketchfabMsg=false"></i>
            </div>
            <div class="tip">
              <p>ThingJS平台支持Sketchfab网站的约10万3D模型资源在ThingJS 3D场景中使用。若您希望使用Sketchfab模型，请按以下步骤操作：</p>
              <p>1.请前往Sketchfab网站注册账号，并确认能正常登录<a href="javascript:void(0);" @click="window.open('https://sketchfab.com')">Sketchfab网站</a>；</p>
              <p>2.请在本页下方填写Sketchfab登录账号、密码，ThingJS平台即可为您下载Sketchfab模型，并可在“在线开发-资源-模型”中使用了；</p>
              <p>3.在ThingJS平台登录Sketchfab成功过后，只要账号正确，以后使用Sketchfab时不用再重复输入。您也可在“控制台-个人信息”界面更新您的Sketchfab账号；</p>
              <p>注意：请使用者尊重Sketchfab模型原作者对模型的版权声明，请按相关版权申请使用相关模型。</p>
            </div>
            <div class="loginSketch">
                <div><span>账号：</span><input type="text" id="username" v-model="name" placeholder="请输入您的Sketchfab账号"></div>
                <div><span>密码：</span><input type="password" id="password" v-model="pwd" placeholder="请输入您的Sketchfab密码" v-on:keyup.enter='writeAccount'></div>
            </div>
            <div class="footer">
              <span class="login" @click="writeAccount">确认登陆</span>
            </div>
          </div>
        </div>
        <div class="signinBox"></div>
        <div id="boxHeader">
          <ModelService @hidePanel=hidePanel v-show="panelShow" :panelShow="panelShow"></ModelService>
          <DevelopService @hidePanelD=hidePanelD v-show="panelShowD" :panelShowD="panelShowD"></DevelopService>
          <CamanyInfoService @hidePanelC=hidePanelC v-show="camShow" ></CamanyInfoService>
        </div>
    </div>
</template>
<script>
    import bus from '../assets/js/eventBus.js';
    import ModelService from './ApplyService.vue';
    import DevelopService from './DevelopService.vue';
    import CamanyInfoService from './CampanyInfo.vue';
    export default {
        name: "header_box",
        components: {
            ModelService,
            DevelopService,
            CamanyInfoService
        },
        data:function(){
            return {
                panelShow: false,
                panelShowD: false,
                isSketchfab:false,
                showSketchfabMsg:false,
                name:'',
                pwd:'',
                para:{},
                sketchfabData:{},
                modelDatailObj:'',
                camShow:false,
            }
        },
        computed: {
          isRootcloud(){
              const CLIENTID = $.cookie('client_id');
              return CLIENTID !== 'rootcloud' ? true : false;
          }
        },
        methods:{
            wapNavPut(){
              window.wapNavPut();
            },
            wapNavOn(){
              window.wapNavOn();
            },
            audittojjles(){
              window.audittojjles();
            },
            hrefPageClick:function (pageName){
              let page = window.location.origin;
              if(page.indexOf('thingjs.com') != -1){
                if(pageName == 'sample'){
                    window.location.href = 'https://www.thingjs.com/guide/?m=sample';
                } else if(pageName == 'zeroCode'){
                  window.location.href = 'https://x.thingjs.com/';
                }else if(pageName == 'studio'){
                  window.location.href = 'https://studio.thingjs.com/zeroCode';
                }else{
                  window.location.href = 'https://www.thingjs.com/guide/' + pageName + '/';
                }
              }else{
                if(pageName == 'sample'){
                    window.location.href = 'https://www.thingjs.com/guide/?m=sample';
                } else if(pageName == 'zeroCode'){
                  window.location.href = 'https://x.thingjs.com/';
                }else if(pageName == 'studio'){
                  window.location.href = 'https://studio.thingjs.com/zeroCode';
                }else{
                  window.location.href = 'https://www.thingjs.com/guide/' + pageName + '/';
                }
              }
            },
            fileclick1: function(flag,prevurl,msg){
                if(flag){
                    var msg = {title:'补充信息',subject:'studio',toolInfo:{data:{title:'补充信息',type:'studio',url:prevurl}}};
                    this.showPanel1(msg)
                    return
                }
                window.open(prevurl)
            },
            pfAltList:function(num){
                switch(num){
                case 1:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('低代码')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS低代码开发平台，面向物联网的3D可视化开发，提供整套开发工具，如3D场景编辑器、2D逻辑图编辑器、地图模型系统、资源库等。')
                    break;
                case 2:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('在线开发VIP')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS在线开发VIP支持更多功能、更高效率的开发数字孪生可视化项目，提供更多源码支持、更大的存储空间和更丰富的功能，让可视化项目开发更便捷。')
                    break;
                case 3:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('离线开发坐席版')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS离线开发SDK是在离线环境使用，每个 Key 对应一台计算机进行开发，开发过程有安全保障，基于浏览器管理，无需安装配置开发环境。')
                    break;
                case 4:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('离线开发网络版')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS离线开发网络版，是在局域网环境部署的数字孪生可视化项目开发服务器。无需外部网络，保障项目安全；支持不限人数的开发人员共同进行数字孪生可视化项目开发，提升开发效率。')
                    break;
                case 5:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('在线部署')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS在线部署支持商用，去掉场景默认水印，发布的项目不带ThingJS 专用 logo。公有云资源完成部署服务器单独部署，无需自建服务器，节约成本。')
                    break;
                case 6:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('离线部署')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS离线部署在本地环境自有服务器部署，无需连接公网，无需云3D资源，保证项目安全性。永久商用授权，项目访问次数无限制。')
                    break;
                case 7:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('零代码')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS-X数字孪生零代码开发平台，无需研发人员，普通业务人员培训3天可独立完成项目。内置丰富模板，开箱即用，提升项目交付效率。')
                    break;
                case 8:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('在线开发VIP')
                    $('.pf-alt-mouse-hover-show-content>p').text('零代码在线开发VIP，高效项目搭建，无需部署，提升实施效率！在线体验园区、城市场景构建，畅享完整工具服务。')
                    break;
                case 9:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('离线开发标准版')
                    $('.pf-alt-mouse-hover-show-content>p').text('零代码离线开发标准版，安全部署离线环境，保障核心数据。多人协作，局域网搭建，高效交付项目。')
                    break;
                case 10:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('项目离线部署')
                    $('.pf-alt-mouse-hover-show-content>p').text('零代码项目离线部署版，安全部署在您的服务器，无需公网连接，保障项目数据安全。永久商用授权，项目访问次数无限制。')
                    break;
                case 11:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森园区')
                    $('.pf-alt-mouse-hover-show-content>p').text('森园区CampusBuilder（模模搭）作为3D园区搭建工具，简单易用、功能强大 ，配合3D 模型库（ThingDepot）丰富的模型资源，提供快速场景搭建能力，致力于帮助非专业人员快速搭建 3D 园区场景。')
                    break;
                case 12:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森机房')
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS-DCV是面向机房管理的专业平台，提供立体化、仿真式、实时互动的可视化管理方式助力提高管理效率。应对复杂机房的管理难题，ThingJS-DCV提供的配套管理功能，助力运维管理人员缩短响应时间，提升工作效率。')
                    break;
                case 13:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森城市')
                    $('.pf-alt-mouse-hover-show-content>p').text('森城市CityBuilder 是3D城市场景搭建工具，提供多种地理图形素材以及可供添加或调节的特殊效果，可轻松制作城市级别3D场景。')
                    break;
                case 14:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森视频')
                    $('.pf-alt-mouse-hover-show-content>p').text('森视频LiveServer提供 GB/T28181 或 RTSP 协议的视频流转换为 H5 视频流的功能，通过对服务器进行相应配置，可轻松实现项目中视频流顺利播放。')
                    break;
                case 15:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森大屏')
                    $('.pf-alt-mouse-hover-show-content>p').text('拖拉拽轻松搭建可视化大屏平台，提供丰富模板库，让可视化大屏无需从零开始搭建；提供数据接入和处理功能，实时展现图表数据；同时可以将3D场景/拓扑拖入森大屏，实现图表等指标数据与三维场景/拓扑进行联动交互。')
                    break;
                case 16:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森模型')
                    $('.pf-alt-mouse-hover-show-content>p').text('森模型ThingDepot（3D模型库系统）模型资源丰富，为搭建场景提供全周期模型资源支持，可直接用于CampusBuilder、CityBuilder等工具快速搭建3D场景，提升三维场景搭建效率。')
                    break;
                case 17:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森拓扑')
                    $('.pf-alt-mouse-hover-show-content>p').text('森拓扑TopoBuilder是一款简单易用、轻量便捷的物联网2D拓扑图绘制工具，支持多人实时在线协作，采用拖拉拽的交互方式，快速完成拓扑图、流程图、工业组态、IT运维等多种场景下视图的绘制。')
                    break;
                case 18:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森Max')
                    $('.pf-alt-mouse-hover-show-content>p').text('森Max是基于3DsMAX二次开发的用于美术生产的工具，可以在单个软件中完成模型与场景制作的所有美术环节，一键烘焙、一键预览、一键上传，并提供在森园区和低代码开发平台的一键使用接口，提高了生产效率及质量效果。')
                    break;
                case 19:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森数据')
                    $('.pf-alt-mouse-hover-show-content>p').text('森数据DIX拥有强大的数据处理能力，内置主流集成插件，提升数据集成效率。适配常见集成协议，支持多种数据格式，解决多源异构问题。')
                    break;
                case 20:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森BIM');
                    $('.pf-alt-mouse-hover-show-content>p').text('森BIMRevit是基于AutoDesk Revit进行的插件开发，能快速获取rvt文件中的模型数据，简单配置后一键导出TJS场景。按照构件的类型将用户不关心的模型合并输出，在一定程度上轻量化导出模型。使用户更聚焦于其关心的设备/孪生体。');
                    break;
                case 21:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('建模服务');
                    $('.pf-alt-mouse-hover-show-content>p').text('解决建模难题，帮助用户快速构建3D模型与城市三维场景，更好的完成项目实施和交付。');
                    break;
                case 22:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('开发服务');
                    $('.pf-alt-mouse-hover-show-content>p').text('通过示例工程，提升用户项目交付质量和规范，更容易形成良好项目质量规范。');
                    break;
                case 23:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('培训服务');
                    $('.pf-alt-mouse-hover-show-content>p').text('通过专业的培训，帮助用户可以更快上手，更容易形成自身高优秀的实施工艺和实施流程。');
                    break;
                case 24:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('支持服务');
                    $('.pf-alt-mouse-hover-show-content>p').text('依托专业原厂技术支持和售后服务，帮助用户更快速解决问题和应对风险。');
                    break;
                case 25:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('开发环境');
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS平台开发授权提供在线开发VIP、离线开发坐席版和离线开发网络版。为您提供完整而灵活的开发环境，协助您轻松开发数字孪生可视化。');
                    break;
                case 26:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('项目部署');
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS部署授权提供在线和离线两种部署方式。在线部署支持商用，公有云资源完成服务部署服务器单独部署，无需自检服务器，节约成本。离线部署在本地环境自有服务器部署，保证项目安全性。');
                    break;
                case 27:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('森建筑');
                    $('.pf-alt-mouse-hover-show-content>p').text('森建筑FacadeEditor是一款聚焦在建筑外立面的建模工具，内置丰富的建筑素材，通过拖拉拽的画布操作和参数化配置，让您可以轻松调整建筑的形状、尺寸和样式细节。');
                    break;
                case 28:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('倾斜摄影服务');
                    $('.pf-alt-mouse-hover-show-content>p').text('倾斜摄影三维建模技术助力整体智慧城市空间数据的生成，帮助客户获得更全面、高效、直观的3D地理信息服务。');
                    break;
                case 29:
                    $('.pf-alt-mouse-hover-show-content>h2>span').text('智慧电力');
                    $('.pf-alt-mouse-hover-show-content>p').text('ThingJS平台智慧电力数字孪生可视化行业模板，通过将配网感知数据与地理空间信息结合，可构建配网调度和抢修指挥的“立体沙盘”，为您的电力管理提供可视化赋能。');
                    break;
                }
            },
          showDevelopPanel:function(){
            this.developPanelShow = true;
          },
          hideDevelopPanel:function(){
            var _this = this;
            this.developPanelShow = false;
          },
          writeMsg(id,index,val,data) {
            this.name='';
            this.pwd='';
            this.showSketchfabMsg=true;
            this.modelDatailObj={
              id:id,
              index:index,
              val:val,
              data:data
            }
          },
          alert(msg,width,height,brnTxt,timeclose) {
            var _this=this;
            var width=width||315;
            var height=height||86;
            var btn=brnTxt||'关闭';
            _this.$Modal.info({
                title: '温馨提示',
                content:`<div class='infoMain infomsg' style='min-height:`+height+`px'><p class='infoBody'><Icon class='info-color ivu-icon ivu-icon-ios-information-circle font-size40'></Icon><span style='top:5px;'>`+msg+`<label class='info-bolder'></span></p></div>`,
                okText: '关闭',
                closable:true,
                width:width,
            });
            if(timeclose) {
              setTimeout(() => {
                _this.$Modal.remove();
              }, 2000);
            }
          },
          writeAccount() {
            var _this=this;
            let para = {
              username:_this.name,
              password:_this.pwd
            };
            if(para.username=='') {
              _this.alert('请输sketchfab账号！');
              return;
            }
            if(para.password=='') {
              _this.alert('请输sketchfab密码！');
              return;
            }
            this.$reqs.post("/user/sketchLogin", para).then(res=>{
                let obj=res.data;
                // console.log(obj)
                if(obj.access_token) {
                  obj.username=para.username;
                  obj.password=para.password;
                  _this.saveSketch(obj);
                } else {
                  _this.alert('账号校验失败<div class="msgmain">Sketchfab返回以下信息:<br>'+_this.skberr(obj)+'</div>',395,136);
                }
            }).catch(err=>{
                console.log(err);
                _this.alert('账号校验失败<div class="msgmain">Sketchfab返回以下信息:<br>'+_this.skberr(err)+'</div>',395,136);
            });
          },
          saveSketch(para){
            var _this=this;
            _this.para=para;
            _this.para.token=$.cookie('token');
            _this.$reqs.post('/user/saveSketchfab',_this.para).then(res=>{
              if(res.data.state==false) {
                _this.alert('账号录入失败<div class="msgmain">网站返回以下信息:<br>'+_this.skberr(res.data.content));
                _this.showSketchfabMsg=false;
              } else {
                _this.alert('账号录入成功！','','','',true);
                setCookie("sketchUser",true);
                sessionStorage.sketchUser=JSON.stringify({access_token:res.data.access_token,refresh_token:res.data.refresh_token});
                this.isSketchfab=true;
                _this.showSketchfabMsg=false;
                _this.previewModel();
              }
            }).catch(err=>{
                console.log(err);
                _this.alert('账号录入失败！');
            });
          },
          skberr(obj) {
            var str='';
              for(let key in obj) {
                if(typeof(obj[key])=='string') str+=`<span>`+key+`：`+obj[key]+`</span>`;
              }
            return `<span class='err'>`+str+`</span>`;
          },
          previewModel(){
            var _this=this;
            _this.modelDatailObj.data.modelDetail(_this.modelDatailObj.id,_this.modelDatailObj.index,_this.modelDatailObj.val);
          },
          showPanel:function(data,title){
              var _this = this;
              var type = data;
              if(data.subject) type = 'Model';

              if($.cookie('openid')){//检查信息
                  let tokenText = $.cookie('token') ? $.cookie('token') : $.cookie('openid');
                  this.$reqs.get("/user/User_info?token="+tokenText).then(function(result) {
                    var infos = result.data;
                    if(data.subject) infos.toolInfo = data;
                    var openPage = '';
                    if(!infos.phoneVerify) openPage = 'phone';
                    if(!infos.office || !infos.company || !infos.namebyCam) openPage = openPage?openPage+'.info':'info';

                    if(openPage){//缺
                        _this.camShow = true;
                        infos.type = 'from'+type+'Server';
                        infos.msg = {title:title,class:type=="dev"?"devBlue":'',pages:openPage,toolInfo:typeof data=="string"?'':data}
                        bus.$emit("openCampanyPanel",{infos:infos});
                    }else{//不缺
                        if(type == "VIP"){
                          updateVIP(false,data);
                        }else{
                          type=="dev"?_this.panelShowD = true:_this.panelShow = true;
                          bus.$emit('panelShow'+type,{infos:infos});
                        }
                    }
                  }).catch(function(error) {
                      console.log(error);
                  });
              }else{
                  logoinForStore(type+"Server");
              }
            //   window.AnalysysAgent && window.AnalysysAgent.track('top_apply_model');
          },
          switchPricePage:function(i){
            switch (i) {
              case 1:
              window.open("https://www.thingjs.com/guide/price/","_self");
              break;
              case 2:
                window.open("https://www.thingjs.com/guide/price/?type=zerocode","_self");
              break;
              case 3:
                window.open("https://www.thingjs.com/guide/price/?type=studio","_self");
              break;
              default:
                break;
            }
          },
          showPanel1:function(msg){
              var _this = this;
              if($.cookie('openid')){//检查信息
                  this.$reqs.get("/user/User_info?token="+$.cookie('token')).then(function(result) {
                    var infos = result.data;
                    var openPage = '';
                    if(!infos.phoneVerify) openPage = 'phone';
                    if(!infos.office || !infos.company || !infos.namebyCam) openPage = openPage?openPage+'.info':'info';
                    // openPage='info';
                    if(openPage){//缺
                        _this.camShow = true;
                        infos.type = 'view';
                        infos.msg = {title:msg.title,subject:msg.subject,pages:openPage,toolInfo:msg.toolInfo}
                        bus.$emit("openCampanyPanel",{infos:infos});
                    }else{//不缺
                        bus.$emit(msg.subject,msg.toolInfo.data);
                    }
                  }).catch(function(error) {
                      console.log(error);
                  });
              }else{
                  logoinForStore();
              }
            //   window.AnalysysAgent && window.AnalysysAgent.track('top_apply_model');
          },
          hidePanel:function(success) {
              var _this = this;
              this.panelShow = false;
          },
          showPanelD:function(){
              if($.cookie('openid')){
                  this.panelShowD = true;
                  bus.$emit('panelShowdev');
              }else{
                  logoinForStore('devServer');
              }
            //   window.AnalysysAgent && window.AnalysysAgent.track('top_request_help');
          },
          hidePanelD:function(success) {
              var _this = this;
              this.panelShowD = false;
              window.parent.postMessage('close','*');
          },
          hidePanelC:function(success) {
              this.camShow = false;
              window.parent.postMessage('closePanel','*');
          },

          forumClick:function(success){
            //    window.AnalysysAgent && window.AnalysysAgent.pageView('ThingJS - 论坛',{$url:'http://developer.thingjs.com'});
          },
          showSignin:function(){
            $(".signinBox").show();
            $(".signinBox").html('<iframe src="https://www.thingjs.com/guide/dialog/signin.html" style="position: absolute;border: 0;width: 385px;height: 537px;top: 50%;left: 50%;transform: translate(-50%,-50%);"></iframe>');
          },
        },
        created: function(){
          var loginSource = window.localStorage.getItem('loginSource');
          if(loginSource && loginSource!=="companyServerFirst"){
              var type = loginSource.indexOf("dev")>-1?"dev":"Model";
              this.showPanel(type);
          }
        },
        mounted:function(){
          var _this=this;
            if (!document.getElementById('qiniuCss')) {  //避免多次引入
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = '/static/lib/regfont/iconfont.css';
                link.id = 'qiniuCss';
                document.body.appendChild(link);
            }
            if (!document.getElementById('CommonJS')) {  //避免多次引入
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = '/static/js/common.js';
                script.id = 'CommonJS';
                document.body.appendChild(script);
            }
            if (!document.getElementById('HeaderJs')) {  //避免多次引入
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://www.thingjs.com/guide/js/header.js';
                script.id = 'HeaderJs';
                document.body.appendChild(script);
            }
            if($.cookie('sketchUser')=='true') {
              this.isSketchfab=true;
              if(sessionStorage.sketchUser){
                this.para=JSON.parse(sessionStorage.sketchUser);
              }
            } else {
              this.isSketchfab=false;
            }
            bus.$on('sales', (data) => {
              if(data.type) {
                    var tOrderId = $.cookie('mmdId') + "."+data.type+"." + data.id;
                        layer.open({
                            type: 2,
                            title: false,
                            closeBtn: 0,
                            area: ['585px', '568px'],
                            content: [
                                window.location.protocol+'//www.thingjs.com/static/payment/createPay/paymentOrder.html?type='+data.type+'&userId=' +
                                $.cookie('mmdId') + '&tOrderId=' + tOrderId, 'no'
                            ],
                            skin: 'buyModelDiv',
                            success:function(){
                                document.getElementsByClassName('buyModelDiv')[0].querySelector('.layui-layer-content').children[0].contentWindow.postMessage({paySource:location.href}, '*');
                            }
                        });
                        window.addEventListener('message', function (event) {
                            if(event.data&&event.data.type&&event.data.type=="newStyle") {
                                $(".buyModelDiv").css({"border-radius":"8px","background-color": "transparent"});
                                $(".buyModelDiv iframe").css("border-radius","8px");
                            }
                            if (event.data == 'close') {
                                layer.closeAll();
                            }
                        })
              } else {
                this.showPanel(data,'项目购买');
              }
            })
            bus.$on('view', (result) => {
              if(result.to){
                bus.$emit(result.to,result.toolInfo.data);
              }else{
                this.showPanel1(result);
              }
            })
            bus.$on('studio', (result) => {
              if(result.url){
                window.open(result.url,"_blank")
              }else{
                return
              }
            })
            bus.$on('fromModelServer', (data) => {
                this.panelShow = true;
                this.camShow = false;
                bus.$emit('panelShowModel',data);
            })
            bus.$on('fromdevServer', (data) => {
                this.panelShowD = true;
                this.camShow = false;
                bus.$emit('panelShowdev',data);
            })
            bus.$on('fromVIPServer', (data) => {
                updateVIP(false,data);
            })
            window.addEventListener("message", function(event) {
              if(event.data == "closeSigin"){
                $(".signinBox").hide();
              }
            })
            // 签到
            var todaySign_show = window.localStorage.getItem('showSign');
            var loginSource = window.localStorage.getItem('loginSource');
            if(todaySign_show && !loginSource){
              this.showSignin();
            }
            window.localStorage.removeItem('loginSource');
            window.localStorage.removeItem('showSign');
            if($.cookie('mmdId')&&$.cookie('token')) {
              $.ajax({
                url:window.location.protocol+'//www.thingjs.com/api/User_info?token='+$.cookie('token'),
                type:'get',
                success:function(res) {
                    if(res&&res.permission == "developer"){
                        $('#headimg').addClass('bordervip');
                        $('#headimgs').addClass('bordervip');
                    }
                    if(res&&res.isVipPro) {
                        $('span.vip').addClass('svip');
                        $('#headimg').addClass('svip');
                        $('#headimgs').addClass('svip');
                    }
                  }
              })
            }
        }
    }

</script>
<style>


  @import '../assets/css/common.css';
</style>
<style>
  @import 'https://www.thingjs.com/guide/css/header.css';
  @import 'https://www.thingjs.com/guide/css/navpingying.css';
  .navHeader {
    background-color: #fff;
  }
  @media only screen and (max-width: 1034px) {
    .collapse #sub-site-nav {
        position: absolute;
        top: 55px;
        left: .15em;
        z-index: 100;
        line-height: .1em;
        background-color: rgba(0,0,0,.8) !important;
        border-radius: .25em;
        height: auto !important;
    }
    .collapse .navbar-nav .nav-link, .nav-href.changNav.contact {
        display: none !important;
    }
  }
  .pageClass.layui-layer.layui-layer-iframe,.layui-layer.layui-layer-iframe .layui-layer-content,.layui-layer.layui-layer-iframe .layui-layer-content iframe {
      background-color: #fff;
      border-radius: 4px;
    }
    .pageClass.layui-layer .layui-layer-btn.layui-layer-btn-c .layui-layer-btn0 {
      background-color: #ff7f00;
      border: 0;
      margin-left: 10px;
      min-width: 140px;
      height: 30px;
      color: #fff;
      outline: none;
    }
    .pageClass.layui-layer .layui-layer-btn.layui-layer-btn-c.active-style a:active  {
      opacity: 0.35 !important;
    }
    .pageClass.layui-layer .layui-layer-btn.layui-layer-btn-c.active-style a:hover  {
      opacity: 0.35 !important;
    }
    .pageClass.layui-layer .layui-layer-btn.layui-layer-btn-c.active-N a{
      opacity: 1 !important;
      cursor: pointer !important;
    }
    .pageClass.layui-layer .layui-layer-btn.layui-layer-btn-c.active-N a:active  {
      opacity: 1 !important;
    }
    .pageClass.layui-layer .layui-layer-btn.layui-layer-btn-c.active-N a:hover  {
      opacity: 0.8 !important;
    }
    .pageClass .layui-layer-title {
      font-size: 16px;
      font-weight: 400;
    }
    .layui-layer.layui-layer-iframe.layui-layer-border.pop-up .layui-layer-content, .layui-layer.layui-layer-iframe.layui-layer-border.pop-up .layui-layer-content iframe {
        border-radius:10px;
    }
  /* .nav-bar{
    color:#ff7a1e !important;
  } */
  .nav-bar::after{
    /* content: '';
    width: 91px;
    height: 76px;
    border-bottom: 3px solid #ff7a1e;
    position: absolute;
    z-index: -1; */
    content: '';
    width: 91px;
    height: 75px;
    border-bottom: 1px solid #ff7a1e;
    background: rgba(23, 22, 22, 0.02) !important;
    position: absolute;
    z-index: -1;
  }

  .signinBox{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    z-index: 1000;
    transform: translate(-50%,-50%);
    background: rgba(0,0,0,.2);
    display: none;
  }

	.template-demos .login-window .tologin-and-mask-box .form-box {
		padding: 0px 41px;
	}
	/* 移动端登录样式 */
	@media only screen and (max-width: 480px){
		.template-demos .login-window {
			width: calc(100% - 20px) !important;
		}
		#verifyCode_tel {
			width: auto;
		}
		.changeVerify_tel {
			line-height: 40px !important;
    		position: absolute;
			right: 0px !important;
		}
		.template-demos .login-window .tologin-and-mask-box .form-box .tologin-input input {
    		width: auto;
		}
		.forgetClass{
			padding: 22px 17px;
		}
	}
	/* @media only screen and (max-width: 360px){
		.template-demos .login-window .tologin-and-mask-box .form-box {
			padding: 0px 6px;
		}
		.forgetClass {
			padding: 22px 0px;
		}
	} */
  </style>
<style>
  @import '../assets/css/writeMsg.css';

</style>




// WEBPACK FOOTER //
// src/components/Header2.vue